export default __webpack_public_path__ + "static/media/IMG3.6bec1fae.JPG";